
import { Mail, MapPin, Clock, Award, Shield, TrendingUp, Star, Wrench, Building, Home } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gradient-to-br from-authority-navy to-trust-deep text-white pt-16 pb-6 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#FFFFFF_1px,transparent_1px)] [background-size:32px_32px]"></div>
      
      <div className="container-custom relative z-10">
        {/* Closure Notice */}
        <div className="bg-gradient-to-r from-red-900 to-red-800 rounded-2xl p-6 mb-12 shadow-2xl border border-red-700/40">
          <div className="text-center">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-2">Colorado First Plumbing and Sewer LLC has permanently closed</h3>
            <p className="text-red-100 max-w-2xl mx-auto">
              After 8 years of serving Colorado families, we&rsquo;ve closed our doors as of March 2026. Thank you for trusting us with your homes and businesses.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <h3 className="text-xl font-bold mb-2 text-neutral-white">Colorado First Plumbing</h3>
              <p className="text-trust-light mb-3">Denver Metro's Most Trusted Plumbers</p>
              
              {/* Trust Badges */}
              <div className="flex items-center space-x-4 mb-4">
                <div className="flex items-center space-x-1 bg-success-light/20 px-3 py-1 rounded-full">
                  <Star size={14} className="text-success-primary fill-current" />
                  <span className="text-success-primary font-bold text-sm">4.8★</span>
                </div>
                <div className="bg-trust-light/20 px-3 py-1 rounded-full">
                  <span className="text-trust-light font-medium text-sm">360 Google Reviews</span>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-trust-primary rounded-full flex items-center justify-center mr-3">
                  <Mail size={14} className="text-white" />
                </div>
                <a href="mailto:contact@bestmasterplumber.com" className="text-trust-light hover:text-white transition-colors">
                  contact@bestmasterplumber.com
                </a>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-success-primary rounded-full flex items-center justify-center mr-3 mt-1">
                  <MapPin size={14} className="text-white" />
                </div>
                <span className="text-trust-light leading-relaxed">
                  Serving Denver Metro, Highlands Ranch, Littleton, Lakewood & surrounding areas
                </span>
              </div>
              
              <div className="flex items-start">
                <div className="w-8 h-8 bg-action-warm rounded-full flex items-center justify-center mr-3 mt-1">
                  <Clock size={14} className="text-white" />
                </div>
                <div>
                  <p className="text-trust-light font-medium">Permanently Closed</p>
                  <p className="text-trust-light/80 text-sm">Closed March 2026 after 8 years of service</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Our Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-neutral-white flex items-center">
              <Wrench size={20} className="text-action-primary mr-2" />
              Our Services
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/residential-plumbing" className="text-trust-light hover:text-action-warm transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-trust-primary/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-action-primary/30 transition-colors">
                    <Home size={12} className="text-trust-primary group-hover:text-action-warm" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Residential Plumbing</span>
                </a>
              </li>
              <li>
                <a href="/sewer-repair-replacement" className="text-trust-light hover:text-action-warm transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-action-urgent/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-action-primary/30 transition-colors">
                    <Wrench size={12} className="text-action-urgent group-hover:text-action-warm" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Sewer Repair & Replacement</span>
                </a>
              </li>
              <li>
                <a href="/commercial-plumbing" className="text-trust-light hover:text-action-warm transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-trust-deep/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-action-primary/30 transition-colors">
                    <Building size={12} className="text-trust-deep group-hover:text-action-warm" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Commercial Plumbing</span>
                </a>
              </li>
              <li>
                <a href="/bathroom-kitchen-remodel" className="text-trust-light hover:text-action-warm transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-success-primary/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-action-primary/30 transition-colors">
                    <Award size={12} className="text-success-primary group-hover:text-action-warm" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Bathroom & Kitchen Remodel</span>
                </a>
              </li>
              <li>
                <a href="/pricing" className="text-trust-light hover:text-success-primary transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-success-light/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-success-primary/30 transition-colors">
                    <TrendingUp size={12} className="text-success-eco group-hover:text-success-primary" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Transparent Pricing</span>
                </a>
              </li>
              <li>
                <a href="/reviews" className="text-trust-light hover:text-success-primary transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-success-light/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-success-primary/30 transition-colors">
                    <Star size={12} className="text-success-eco group-hover:text-success-primary" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Customer Reviews</span>
                </a>
              </li>
            </ul>
          </div>
          
          {/* Service Areas */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-neutral-white flex items-center">
              <MapPin size={20} className="text-success-primary mr-2" />
              Service Areas
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/highlands-ranch-plumber" className="text-trust-light hover:text-success-primary transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-success-light/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-success-primary/30 transition-colors">
                    <MapPin size={12} className="text-success-primary group-hover:text-success-eco" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Highlands Ranch Plumber</span>
                </a>
              </li>
              <li>
                <a href="/littleton-plumber" className="text-trust-light hover:text-success-primary transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-success-light/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-success-primary/30 transition-colors">
                    <MapPin size={12} className="text-success-primary group-hover:text-success-eco" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Littleton Plumber</span>
                </a>
              </li>
              <li>
                <a href="/lakewood-plumber" className="text-trust-light hover:text-success-primary transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-success-light/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-success-primary/30 transition-colors">
                    <MapPin size={12} className="text-success-primary group-hover:text-success-eco" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">Lakewood Plumber</span>
                </a>
              </li>
              <li>
                <a href="/" className="text-trust-light hover:text-white transition-colors inline-flex items-center group">
                  <div className="w-6 h-6 bg-trust-light/20 rounded-full flex items-center justify-center mr-3 group-hover:bg-trust-primary/30 transition-colors">
                    <Home size={12} className="text-trust-light group-hover:text-white" />
                  </div>
                  <span className="group-hover:translate-x-1 transition-transform duration-200">All Service Areas</span>
                </a>
              </li>
            </ul>
            
            {/* Additional Areas */}
            <div className="mt-6 pt-4 border-t border-trust-light/20">
              <p className="text-trust-light/80 text-sm mb-2 font-medium">Also Serving:</p>
              <p className="text-trust-light/70 text-sm leading-relaxed">
                Denver • Arvada • Thornton • Castle Rock • Loveland • Centennial • Ken Caryl • Columbine • Westminster
              </p>
            </div>
          </div>
          
          {/* Trust & Credentials */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-neutral-white flex items-center">
              <Shield size={20} className="text-success-primary mr-2" />
              Why Colorado First?
            </h3>
            <div className="space-y-4">
              <div className="bg-success-light/10 rounded-lg p-4 border border-success-primary/20">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gradient-to-r from-success-primary to-success-eco rounded-full flex items-center justify-center mr-3 mt-1">
                    <Award size={16} className="text-white" />
                  </div>
                  <div>
                    <p className="text-neutral-white font-bold">Master Plumber Owned</p>
                    <p className="text-sm text-success-light/90">Licensed professionals with Expert sewer knowledge</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-trust-light/10 rounded-lg p-4 border border-trust-primary/20">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gradient-to-r from-trust-primary to-trust-deep rounded-full flex items-center justify-center mr-3 mt-1">
                    <Shield size={16} className="text-white" />
                  </div>
                  <div>
                    <p className="text-neutral-white font-bold">Fully Licensed & Insured</p>
                    <p className="text-sm text-trust-light/90">BBB A+ rating • Complete liability coverage</p>
                  </div>
                </div>
              </div>
              
              <div className="bg-action-primary/10 rounded-lg p-4 border border-action-primary/20">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-gradient-to-r from-action-primary to-action-urgent rounded-full flex items-center justify-center mr-3 mt-1">
                    <TrendingUp size={16} className="text-white" />
                  </div>
                  <div>
                    <p className="text-neutral-white font-bold">Transparent Pricing</p>
                    <p className="text-sm text-action-warm/90">See actual prices online • No hidden fees</p>
                  </div>
                </div>
              </div>
              
              {/* Social Proof */}
              <div className="mt-6 p-4 bg-gradient-to-r from-neutral-white/5 to-success-light/5 rounded-lg border border-success-primary/30">
                <div className="flex items-center justify-center mb-3">
                  <div className="flex space-x-1 text-success-primary">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={18} className="fill-current" />
                    ))}
                  </div>
                </div>
                <p className="text-center text-neutral-white font-bold text-lg">4.8★ Rating</p>
                <p className="text-center text-trust-light text-sm">360+ Verified Google Reviews</p>
                <a 
                  href="/reviews"
                  className="block w-full mt-3 bg-gradient-to-r from-success-primary to-success-eco hover:shadow-lg hover:scale-[1.02] text-white px-4 py-2 rounded-lg text-sm font-semibold text-center transition-all duration-300"
                >
                  View All Reviews
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Section */}
        <div className="pt-8 mt-8 border-t border-trust-light/20">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <div className="mb-6 lg:mb-0">
              <p className="text-trust-light/80 text-sm mb-2">
                &copy; {currentYear} Colorado First Plumbing and Sewer LLC. All rights reserved.
              </p>
              <div className="flex flex-wrap gap-4 text-xs text-trust-light/60">
                <span>Colorado Licensed Master Plumber</span>
                <span>•</span>
                <span>Serving Denver Metro Since 2018</span>
                <span>•</span>
                <span>BBB A+ Rating</span>
              </div>
            </div>
            
            {/* Social Media - Enhanced */}
            <div className="flex flex-col items-center lg:items-end">
              <p className="text-trust-light text-sm mb-3 font-medium">Follow Us for Plumbing Tips</p>
              <div className="flex space-x-4">
                <a 
                  href="https://www.facebook.com/coloradoplumbing" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-trust-primary/20 hover:bg-trust-primary rounded-full flex items-center justify-center text-trust-primary hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg"
                  aria-label="Facebook"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"></path>
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/coloradofirstplumbing" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-action-primary/20 hover:bg-action-primary rounded-full flex items-center justify-center text-action-primary hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg"
                  aria-label="Instagram"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.045-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd"></path>
                  </svg>
                </a>
                <a 
                  href="https://www.tiktok.com/@milehighplumber" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-success-primary/20 hover:bg-success-primary rounded-full flex items-center justify-center text-success-primary hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg"
                  aria-label="TikTok"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"></path>
                  </svg>
                </a>
                <a 
                  href="https://www.youtube.com/@bestmasterplumber" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-action-urgent/20 hover:bg-action-urgent rounded-full flex items-center justify-center text-action-urgent hover:text-white transition-all duration-300 hover:scale-110 hover:shadow-lg"
                  aria-label="YouTube"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M23.498 6.186a3.016 3.016 0 01-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 01.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 012.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 012.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
